import moment from 'moment-timezone';

/**
 * Everything that reads the current runtime moment / current timezone.
 * These helpers take no timestamp input — the "input" is whenever the
 * function was called and where the browser is.
 */

export const getCurrentMomentInTimezone = (timezone) => {
	const currentMoment = moment();
	const momentInTimezone = currentMoment.clone().tz(timezone);

	return momentInTimezone;
};

export const getTodayStartWithTimezone = (timezone = moment.tz.guess()) => {
	const tz = typeof timezone === 'string' ? timezone : timezone?.value || moment.tz.guess();
	return moment().tz(tz).startOf('day').toISOString();
};

export const getNowInUtc = () => {
	return moment.utc().format();
};

/**
 * Human-readable current timezone label — "<IANA name> UTC ±<hours>".
 */
export const getTimezone = () => {
	const timezone = moment.tz.guess();
	const utcOffsetHours = moment().utcOffset() / 60;
	const offsetSign = utcOffsetHours > 0 ? '+' : '';

	return `${timezone} UTC ${offsetSign}${utcOffsetHours}`;
};
